import firebase from 'firebase/app'
import 'firebase/firestore'

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBeJd0GyuJZBl7lg1fqda9u4APkdMr3s54',
  authDomain: 'quantitative-01.firebaseapp.com',
  databaseURL: 'https://quantitative-01.firebaseio.com',
  projectId: 'quantitative-01',
  storageBucket: 'quantitative-01.appspot.com',
  messagingSenderId: '894626514497',
  appId: '1:894626514497:web:abf48e48be935eea8228c0'
}

// Get a Firestore instance
const firebaseApp = firebase.initializeApp(firebaseConfig)

export const db = firebaseApp
